import { render, staticRenderFns } from "./PayerAdd.vue?vue&type=template&id=312c3475&scoped=true&"
import script from "./PayerAdd.vue?vue&type=script&lang=js&"
export * from "./PayerAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312c3475",
  null
  
)

export default component.exports